// extracted by css-extract-rspack-plugin
export default {"checkbox":"Checkbox-module__checkbox___WDmBl"};